import { AssignmentCategory } from '../types/alarm';
import { defaultSetService } from './defaultSetService';

/**
 * 과제 카테고리 서비스
 * 내부적으로 defaultSetService를 사용하여 setCollection/DefaultSet 문서에서 관리
 */
export const assignmentCategoryService = {
  async loadCategories(userId: string, classId: string): Promise<AssignmentCategory[]> {
    return defaultSetService.loadCategories(userId, classId);
  },
  
  async saveCategory(userId: string, classId: string, category: AssignmentCategory): Promise<void> {
    return defaultSetService.saveCategory(userId, classId, category);
  },
  
  async deleteCategory(userId: string, classId: string, categoryId: string): Promise<void> {
    return defaultSetService.deleteCategory(userId, classId, categoryId);
  }
};

